import { z } from 'zod';

import {
    PAYMENT_METHODS,
    paymentAllocationInputSchema,
    paymentRecordObjectSchema,
    refinePaymentRecord,
} from '@/entities/payment';

export const recordPaymentFormSchema = paymentRecordObjectSchema
    .omit({ id: true, practiceId: true, practiceMemberId: true })
    .extend({
        allocations: z.array(paymentAllocationInputSchema).min(1, 'Select at least one session'),
        method: z.enum(PAYMENT_METHODS, 'Select a payment method').exclude(['CARD_ON_FILE']),
    })
    .superRefine(refinePaymentRecord);

export type RecordPaymentFormValues = z.input<typeof recordPaymentFormSchema>;
export type RecordPaymentFormOutput = z.output<typeof recordPaymentFormSchema>;
